import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import './index.css';
import App from './App';
import {setAuthorizationHeader} from "./util/SecurityUtils";
import { ThemeProvider } from './context/ThemeContext';
import { queryClient } from "./lib/queryClient";

const root = ReactDOM.createRoot(document.getElementById('root'));
setAuthorizationHeader();
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);
